<template>
    <article class="team-member pt-5 pb-5 bg-bottom">
        <div class="container">
            <div class="media">
                <figure>
                    <img src="../assets/team-members/big/roman.png" alt="">
                </figure>
                <div class="media-body">
                    <h5 class="mt-0">Roman Meytin</h5>
                    <h6 class="mb-5">Founder & CEO at <span>Empower Direct</span></h6>
                    <p>
                        A business owner and marketing, analytics, and web development expert for over 20 years, Roman oversees all projects, clients, and staff at Empower Direct and ensures both its vision and mission are achieved. While he calls Baltimore home, his marketing career began at 12 years old outside Rome - building and selling bikes in a Soviet refugee community. Pairing his passion for people with his love of technology, Roman has built a robust, talented, and diverse team at Empower Direct to serve clients worldwide. Under Roman's leadership, Empower Direct takes a strategic, data-driven approach to everything they do. Roman holds a degree in Psychology and Computer Science from the University of Maryland at College Park. His business interests and endeavors range from marketing to technology startups and real estate.
                    </p>

                    <p>
                        Contact Roman to discuss how he and his team at Empower Direct can help your business: <a href="mailto:roman@empowerdirect.io">roman@empowerdirect.io</a>
                    </p>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'RomanMeytin',
    };
</script>

<style scoped>

</style>
